import { translationClearanceStatuses } from "../../data";

export const PatientSurgeryAssessmentMadeTable = ({ patientSurgery }) => {
  return (
    <div className="table-responsive">
      <table className="table">
        <thead className="table-primary">
          <tr>
            <th className="border-bottom p-3">Indicador</th>
            <th className="border-bottom p-3">Valor</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="py-3">Protocolo</td>
            <td className="py-3 whitespace-pre-line">{patientSurgery.protocol}</td>
          </tr>
          <tr>
            <td className="py-3">Número de sesiones</td>
            <td className="py-3">{patientSurgery.numberEvents}</td>
          </tr>
          {patientSurgery.clearanceStatus !== null && (
            <tr>
              <td className="py-3">Autorizado para procedimiento</td>
              <td className="py-3">
                {translationClearanceStatuses[patientSurgery.clearanceStatus]}
              </td>
            </tr>
          )}
          {patientSurgery.clearanceNote !== null && (
            <tr>
              <td className="py-3">Motivo</td>
              <td className="py-3">{patientSurgery.clearanceNote}</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
